import { AppThunk } from '../../../store/types';
import {
  setClientOrdersSearchAction,
  setClientOrdersSearchErrorAction,
  setClientOrdersSearchFetchStatusAction,
  setClientOrdersSettingsAction,
} from './reducer';
import { createFetchedSuccess, createFetchedWithError, createFetchInProgress } from 'types/rest/IFetchStatus';
import { Logger } from '../../../ui-toolkit/logging/LoggerService';
import { searchByParametersClient } from '../../../ui-toolkit/orders/searchOrder/API/SearchOrdersAPI';
import { ISearchOrdersSpecificationData } from '../../../ui-toolkit/orders/searchOrder/types/ISearchOrdersSpecification';
import { ISearchOrderResultData } from '../../../ui-toolkit/orders/searchOrder/types/ISearchOrdersResult';
import { getSearchOrdersOrderBy } from '../../../ui-toolkit/orders/searchOrder/types/eSearchOrdersOrderBy';

export const getClientOrdersSearch =
  (parameters: ISearchOrdersSpecificationData): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(setClientOrdersSearchErrorAction(null));
      dispatch(setClientOrdersSearchFetchStatusAction(createFetchInProgress()));
      const response: ISearchOrderResultData = await searchByParametersClient(parameters);
      dispatch(setClientOrdersSearchAction(response));
      dispatch(setClientOrdersSearchFetchStatusAction(createFetchedSuccess()));
    } catch (e: any) {
      dispatch(setClientOrdersSearchFetchStatusAction(createFetchedWithError()));
      dispatch(setClientOrdersSearchErrorAction(e.message));
    }
  };

export const initClientOrdersSearch =
  (): AppThunk =>
  (dispatch, getState) => {
    const fetchStatus = getState().clientOrdersSearch.searchResultFetchStatus;
    const parameters = getState().clientOrdersSearch.searchSettings;
    if (!fetchStatus.fetching && !fetchStatus.fetched) {
      dispatch(getClientOrdersSearch(parameters));
    }
  };

export const setClientSearchSettings =
  (settings: ISearchOrdersSpecificationData): AppThunk =>
  (dispatch) => {
    dispatch(setClientOrdersSettingsAction(settings));
    dispatch(getClientOrdersSearch(settings));
  };

export const setClientSearchOrderSorting =
  (field: string, order: 'asc' | 'desc'): AppThunk =>
  (dispatch, getState) => {
    const parameters = getState().clientOrdersSearch.searchSettings;
    const sortBy = getSearchOrdersOrderBy(field, order);
    if (sortBy && sortBy !== parameters.sortBy) {
      dispatch(setClientSearchSettings({ ...parameters, sortBy }));
    }
    if (!sortBy) {
      Logger.error(`Sorting incorrect`, `${field}${order}`);
    }
  };
